export const DAYS_MASK = [
  { mask: "" },
  {
    mask: "n days",
    lazy: false,
    expose: true,
    blocks: {
      n: {
        mask: Number,
        expose: true,
      },
      days: {
        mask: "d\\ays",
      },
    },
  },
];
export const DOLLAR_MASK = "$ num";
